import React, { useEffect } from 'react';
import { useState } from 'react';
import { FormHelperText, Grid, InputLabel, Typography } from '@material-ui/core';
import { DateTimePicker, SecondaryButton, SelectBox, TextBox } from '../../../../../../Core/FormInput';
import { postCommunicator_AssignToJob, postJobProgressOtherStatus, postUpdateTCardMOTDetails } from '../../../../../../Core/Service/communicator-service';
import { useContext } from 'react';
import AppContext from '../../../../../../App/AppContext';
import { singleEmailValidation } from '../../../../../../Core/Service/StaticService';

const CommonStatusModal = (props) => {
    const { showToast } = useContext(AppContext);

    const [state, setState] = useState({
        messaegList: [],
        actionLog: false,
        editActionLog: false,
        selectedStatus: props.selectedStatus,
        logText: '',
        errors: {},
        technicianId: props.technicianUserID,
        mOTLocation: props.state?.motLocation,
        mOTDate: props.state?.motDate
    });

    useEffect(async () => {
        setState((st) => ({ ...st, logText: props.smsText, isCustomerUpdate: props.sendSMSUpdate, isUpdateSms: props.sendSMSUpdate }));
    }, [props]);

    const handleInput = (e) => {
        const { name, value, type, checked } = e.target;
        if (type == 'checkbox') {
            setState((st) => {
                let newSt = { ...st };
                newSt[name] = checked;
                if (!newSt.isCustomerUpdate) {
                    newSt.isCustomerEmail = '';
                }
                if (!newSt.isUpdateSms) {
                    newSt.isPhoneNo = '';
                }
                return newSt;
            });
        } else {
            setState((st) => ({ ...st, [name]: value }));
        }
    };

    const validation = () => {
        let { isCustomerUpdate, isCustomerEmail, isUpdateSms, isPhoneNo } = state;
        let isValid = true;
        let errors = {};

        if (isCustomerUpdate && !singleEmailValidation(isCustomerEmail)) {
            isValid = false;
            errors.isCustomerEmail = 'Please Add Customer Email';
        }
        if (isUpdateSms && !isPhoneNo) {
            isValid = false;
            errors.isPhoneNo = 'Please Add Customer Email';
        }

        setState((st) => ({ ...st, errors: errors }));
        return isValid;
    };

    const handleSubmit = async () => {
        if (validation()) {
            let data = {
                // headerRecordID: props.headerRecordID,
                tCardID: props.tCardID,
                status: +state.selectedStatus,
                logText: state.logText,
                isPhoneNo: state.isPhoneNo,
                isCustomerEmail: state.isCustomerEmail
            };
            let assignedData = {
                // headerRecordID: props.headerRecordID,
                tCardID: props.tCardID,
                technicianId: state.technicianId
            };
            let MotData = {
                // headerRecordID: props.headerRecordID,
                tCardID: props.tCardID,
                mOTLocation: state.mOTLocation || 'Test',
                mOTDate: state.mOTDate
            };
            if (props.selectedStatus == 11) {
                // For Assigned Status
                let res = await postCommunicator_AssignToJob(assignedData);
                if (res.success) {
                    showToast(` Job Assigned Successfully`);
                    props.onClose(true);
                } else {
                    showToast(res.message);
                }
            } else if (props.selectedStatus == 6) {
                // For Assigned Status
                let res = await postUpdateTCardMOTDetails(MotData);
                if (res.success) {
                    showToast(` Job Assigned Successfully`);
                    props.onClose(true);
                } else {
                    showToast(res.message);
                }
            } else {
                let res = await postJobProgressOtherStatus(data);
                if (res.success) {
                    showToast(`${props.btnTitle} Added Successfully`);
                    props.onClose(true);
                } else {
                    showToast(`${props.btnTitle} Failed To Add`);
                }
            }
        }
    };

    useEffect(() => {
        let obj = props.statusList || {};
        setState((st) => ({
            ...st,
            isCustomerUpdate: obj?.sendEmail,
            isUpdateSms: obj?.sendSMSUpdate,
            isCustomerEmail: obj?.email,
            isPhoneNo: obj?.phone,
            logText: obj?.smsText,
            isPhoneVisible: obj?.sendSMSUpdate,
            isEmailVisible: obj?.sendEmail,
            noDataVisible: !obj.sendSMSUpdate && !obj.sendEmail
        }));
    }, [props.statusList]);

    return (
        <div>
            <Grid container spacing={2}>
                {/* // For Assigned Status  */}
                {props.selectedStatus == 11 ? (
                    <Grid item xs={12}>
                        <Typography color="secondary">Technician</Typography>
                        <SelectBox List={props.technicians || []} name="technicianId" value={state.technicianId} onChange={handleInput} />
                    </Grid>
                ) : props.selectedStatus == 6 ? (
                    <>
                        <Grid item xs={6}>
                            <InputLabel shrink style={{ marginBottom: 8 }}>
                                MOT Date
                            </InputLabel>
                            <DateTimePicker placeholder="Message" name="mOTDate" variant="outlined" fullWidth value={state.mOTDate} onChange={handleInput} />
                        </Grid>
                        <Grid item xs={6}>
                            <InputLabel shrink>MOT Location</InputLabel>
                            <TextBox
                                placeholder="MOT Location"
                                type="text"
                                name="mOTLocation"
                                variant="outlined"
                                fullWidth
                                value={state.mOTLocation}
                                onChange={handleInput}
                            />
                            {/* <FormHelperText error>{state.errors.logText}</FormHelperText> */}
                        </Grid>
                    </>
                ) : (
                    <>
                        <Grid item xs={12}>
                            <Typography color="secondary">Customer Message</Typography>
                            <TextBox
                                placeholder="Message"
                                rows={3}
                                multiline
                                type="text"
                                name="logText"
                                variant="outlined"
                                fullWidth
                                value={state.logText}
                                onChange={handleInput}
                            />
                            <FormHelperText error>{state.errors.logText}</FormHelperText>
                        </Grid>

                        {state.isEmailVisible && (
                            <Grid item xs={12} md={8}>
                                <InputLabel shrink>
                                    <input
                                        type="checkbox"
                                        style={{ cursor: 'pointer' }}
                                        name="isCustomerUpdate"
                                        onChange={handleInput}
                                        checked={state.isCustomerUpdate}
                                    />
                                    Customer Email
                                </InputLabel>
                                <TextBox
                                    placeholder="Email update to customer"
                                    type="email"
                                    name="isCustomerEmail"
                                    variant="outlined"
                                    fullWidth
                                    value={state.isCustomerEmail}
                                    onChange={handleInput}
                                    error={state.isCustomerUpdate}
                                />
                                <FormHelperText error>{state.errors.isCustomerEmail}</FormHelperText>
                            </Grid>
                        )}
                        {state.isPhoneVisible && (
                            <Grid item xs={12} md={4}>
                                <InputLabel shrink>
                                    <input
                                        type="checkbox"
                                        style={{ cursor: 'pointer' }}
                                        onChange={handleInput}
                                        name="isUpdateSms"
                                        checked={state.isUpdateSms}
                                    />
                                    Phone Number
                                </InputLabel>
                                <TextBox
                                    placeholder="Phone Number"
                                    type="tel"
                                    name="isPhoneNo"
                                    variant="outlined"
                                    fullWidth
                                    value={state.isPhoneNo}
                                    onChange={handleInput}
                                    error={state.isUpdateSms}
                                />
                                <FormHelperText error>{state.errors.isPhoneNo}</FormHelperText>
                            </Grid>
                        )}
                    </>
                )}
            </Grid>
            <Grid item xs={12}>
                <SecondaryButton className="Submitbtn" fullWidth onClick={handleSubmit}>
                    {props.selectedStatus == 11 ? 'Assign Technician ' : props.selectedStatus == 6 ? 'MOT PREP' : props.btnTitle}
                </SecondaryButton>
            </Grid>
        </div>
    );
};

export default CommonStatusModal;
